import React, {Fragment, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {makeStyles, withStyles} from '@material-ui/core/styles'
import {DataGrid} from '@material-ui/data-grid'
import moment from 'moment'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import LockScreenLoading from "../LockScreenLoading/LockScreenLoading";
import {getScanFile, cancelScanFile, downloadScanFile} from '../../dataSource/fileScan'
import {Button, Typography} from '@material-ui/core'

const ScanFileList = ({
                          scanfileList,
                          setScanFileList,
                          filteredScanfileList,
                          setFilteredScanFileList,
                          selection,
                          setSelection,
                          scanValidationErrors,
                          setScanValidationErrors,
                      }) => {
    const dispatch = useDispatch()
    const folderSelectedResult = useSelector((state) => state.folderSelectedRedux)

    const [progressTitle, setProgressTitle] = useState("")
    const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false)

    const [updateList, setUpdateList] = useState(false)
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
    const [confirmDialogData, setConfirmDialogData] = useState({
        dialogTitle: '',
        dialogContent: '',
        confirmAction: '',
        cancelAction: '',
    })

    const getScanFileList = async () => {
        let response = await getScanFile()

        let data = response.data.map((obj, index) => {
            return {
                id: obj.file_seq,
                folder_seq: folderSelectedResult.folder_seq,
                file_subject: '',
                company_seq: 0,
                company_seq_option: null,
                inout: 'NA',
                is_confidential: false,
                ref_no: '',
                remark: '',
                fileExist: false,
                date_of_document: null,
                ...obj,
            }
        })
        setScanFileList(data)
    }

    const getDateTimeDifferentDesc = (date) => {
        // Get the current time
        const currentTime = moment()
        const providedTime = moment(date)
        // Calculate the difference between the provided time and the current time
        const diffInMilliseconds = currentTime.diff(providedTime)
        // Convert the difference to a human-readable format
        const duration = moment.duration(diffInMilliseconds)
        const diffInSeconds = duration.asSeconds().toFixed(0)
        const diffInMinutes = duration.asMinutes().toFixed(0)
        const diffInHours = duration.asHours().toFixed(0)

        if (diffInHours >= 24) {
            return moment(date).format('YYYY/MM/DD')
        } else if (diffInMinutes > 60) {
            return `In ${diffInHours} hours`
        } else if (diffInSeconds > 60) {
            return `In ${diffInMinutes} minutes`
        } else {
            return `In ${diffInSeconds} seconds`
        }
    }

    const columns = [
        {
            field: 'id',
            hide: 'true',
        },
        {
            field: 'scan_file_seq',
            hide: 'true',
        },
        {
            field: 'file_seq',
            hide: 'true',
        },
        {
            field: 'filename',
            headerName: 'File Name',
            width: 350,
        },
        {
            field: 'file_size',
            headerName: 'File Size',
            renderCell: (params) => <span>{params.value}</span>,
            width: 150,
        },
        {
            field: 'scan_date',
            headerName: 'Scan Date',
            renderCell: (params) => (
                <span>{getDateTimeDifferentDesc(params.value)}</span>
            ),
            width: 150,
        },
        {
            field: 'expiry_date',
            headerName: 'Expiry Date',
            renderCell: (params) => (
                <span>{moment(params.value).format('YYYY/MM/DD')}</span>
            ),
            width: 150,
        },
        {
            field: 'status',
            headerName: 'Status',
            renderCell: (params) => (
                // <span>{params.value ? params.row.status ? 'Processing' : 'Error' : 'Available'}</span>
                <span>{params.value === 'Y' ? 'Available' : params.value === 'E' ? 'Error' : params.value === 'P' ? 'Processing' : ''}</span>
            ),
            width: 120,
        },
        {
            field: 'test',
            headerName: 'Action',
            sortable: false,
            renderCell: (params) => (
                <span>
					{renderActionButtons(
                        params.row.status,
                        params.row.filename,
                        params.row.scan_file_seq
                    )}
				</span>
            ),
            width: 240,
        },
        // { field: "createuser_fullname", headerName: "Create User", width: 250 },
    ]

    const renderActionButtons = (status, filename, scan_file_seq) => {
        return (
            <strong>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{marginLeft: 16}}
                    disabled={status === 'E' || status === 'P'}
                    onClick={() => {
                        downloadScanFileAction(scan_file_seq)
                    }}
                >
                    Download
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    disabled={status === 'P'}
                    style={{marginLeft: 16}}
                    onClick={() => {
                        cancelScanFileActionHandleOpen(filename, scan_file_seq)
                    }}
                >
                    Delete
                </Button>
            </strong>
        )
    }

    const cancelScanFileAction = async (scan_file_seq) => {
        cancelScanFile(scan_file_seq).then(() => {
            cancelScanFileActionHandleClose()
            setUpdateList((prev) => !prev)
        })
    }

    const downloadScanFileAction = (scan_file_seq) => {
        console.log('Download Scan File: ' + scan_file_seq)

        setProgressTitle("Downloading...")
        setLockScreenLoadingOpen(true)

        downloadScanFile(scan_file_seq).then(() => {
            console.log("file download successful.")
            setLockScreenLoadingOpen(false)
            setProgressTitle("")
        })
    }

    const checkBoxModelChange = (newSelection) => {
        setSelection(newSelection.selectionModel)
        let scanErrors = [...scanValidationErrors]
        let scanFileList = []
        if (filteredScanfileList.length === 0) {
            scanFileList = scanfileList.filter((obj) =>
                newSelection.selectionModel.some((value) => obj.id === value)
            )
        } else {
            scanFileList = [...filteredScanfileList]
            for (let selectedCheck of newSelection.selectionModel) {
                if (
                    scanFileList.findIndex((obj) => obj.file_seq === selectedCheck) === -1
                ) {
                    let add = scanfileList.find((obj) => obj.file_seq === selectedCheck)
                    scanFileList = [...scanFileList, add]
                }
            }
            for (let [i, element] of scanFileList.entries()) {
                if (newSelection.selectionModel.indexOf(element.file_seq) === -1) {
                    scanFileList.splice(i, 1)
                    scanErrors.splice(i, 1)
                }
            }
        }
        if (newSelection.selectionModel.length === 0) {
            scanFileList = []
            scanErrors = []
        }
        setFilteredScanFileList(scanFileList)
        setScanValidationErrors(scanErrors)
    }

    useEffect(() => {
        const getFile = async () => {
            await getScanFileList()
        }
        getFile()
    }, [updateList])

    const cancelScanFileActionHandleOpen = (filename, scan_file_seq) => {
        confirmDialogHandleOpen({
            dialogTitle: 'Cancel scanned file',
            dialogContent: `Are you sure to cancel the scanned file "${filename}"`,
            confirmAction: () => cancelScanFileAction(scan_file_seq),
            cancelAction: cancelScanFileActionHandleClose,
        })
    }

    const cancelScanFileActionHandleClose = () => {
        confirmDialogHandleClose()
    }

    // Confirm dialog
    const confirmDialogHandleOpen = (data) => {
        setConfirmDialogData({
            dialogTitle: data.dialogTitle,
            dialogContent: data.dialogContent,
            confirmAction: data.confirmAction,
            cancelAction: data.cancelAction,
        })

        setConfirmDialogOpen(true)
    }

    const confirmDialogHandleClose = () => {
        setConfirmDialogOpen(false)
    }

    const reloadScanFileListAction = () => {
        setUpdateList((prev) => !prev)
    }

    return (
        <Fragment>
            <LockScreenLoading
                open={lockScreenLoadingOpen}
                circleSize={200}
                progressTitle={progressTitle}
            />

            <ConfirmDialog
                open={confirmDialogOpen}
                dialogTitle={confirmDialogData.dialogTitle}
                dialogContent={confirmDialogData.dialogContent}
                confirmAction={confirmDialogData.confirmAction}
                cancelAction={confirmDialogData.cancelAction}
            />

            <div style={{width: '100%', height: '500px'}}>
                <Typography>
                    <p>Please contact IT to set up the scanner.</p>
                    <p>
                        The file will be shown after the scanner transfer to system, and
                        only completed file can be selected to use.
                    </p>
                    <p>All files will be removed after 90days from the scanned date.</p>
                </Typography>
                <br/>

                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{marginLeft: 16}}
                    onClick={() => {
                        reloadScanFileListAction()
                    }}
                >
                    Reload
                </Button>
                <DataGrid
                    rows={scanfileList}
                    checkboxSelection
                    onSelectionModelChange={(newSelection) => {
                        checkBoxModelChange(newSelection)
                    }}
                    disableSelectionOnClick
                    selectionModel={selection}
                    columns={columns}
                    pageSize={10}
                    isRowSelectable={(params) => params.row.status === "Y"}
                />
                <br/>
            </div>
        </Fragment>
    )
}

export default ScanFileList
